module.exports = __webpack_public_path__ + "static/media/mangomousse.f25834ba.jpg";